import { translocoConfig } from '@ngneat/transloco';
const ɵ0 = translocoConfig({
    reRenderOnLangChange: true,
    fallbackLang: 'en',
    availableLangs: ['en', 'nl', 'fr'],
    defaultLang: 'en',
    missingHandler: {
        logMissingKey: false,
        useFallbackTranslation: true
    }
});
export class CommonTranslateModule {
}
export { ɵ0 };
